import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Toolbar, IconButton, Paper
} from '@mui/material';
import { makeStyles, useTheme } from '@mui/styles';
import MenuIcon from '@mui/icons-material/Menu';
import { useTranslation } from '../common/components/LocalizationProvider';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { sessionActions } from '../store';
import { nativePostMessage } from '../common/components/NativeInterface';

const useStyles = makeStyles((theme) => ({
  toolbar: {
    display: 'flex',
    gap: theme.spacing(1),
    borderBottomLeftRadius: '30px',
    borderBottomRightRadius: '30px',
    backgroundColor: theme.palette.primary.main,
  },

  arrowButton: {
    color: '#fff',
  },
  
}));

const ComponentToolbar = ({

}) => {
  const user = useSelector((state) => state.session.user);
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const t = useTranslation();
  
  const toolbarRef = useRef();

  return (
    <Paper square className={classes.toolbar} elevation={4}>
      <Toolbar ref={toolbarRef} >
        <IconButton className={classes.arrowButton} edge="start" onClick={(event) => navigate(-1)}>
          <ArrowBackIcon />
        </IconButton>
      </Toolbar>
    </Paper>
  );
};

export default ComponentToolbar;
